import { JourneyStep } from '../../types/journey-steps';

// Do not import this directly within a component.
// You should use the useJourneySteps() function, as that
// will include the logic of which journey a user should be in.
export const defaultCaravanSearchJourney: JourneyStep[] = [
  {
    name: 'Park',
    pathName: '/search-results/caravans/parks',
    title: 'Park',
    fields: [{ name: 'parkCode' }],
  },
  {
    name: 'Search results',
    pathName: '/search-results/caravans',
    title: 'Search results',
    fields: [{ name: 'id' }],
  },
  {
    name: 'Holiday details',
    pathName: '/search-results/caravans/details',
    title: 'Holiday details',
  },
];
